module.exports = __webpack_public_path__ + "img/uploadIcon.e201e4c6.svg";